import { Component, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { environment } from '../../environments/environment';
import { HttpService } from '../shared/services/http.service';
import { PageMetadataService } from '../shared/services/page-metadata.service';
import { ApiService } from '../api.service';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../utility';
import { HomeService } from '../home/home.service';
import { HelperService } from '../shared/services/helper.service';
import { SidebarService } from '../shared/services/sidebar.service';

@Component({
  selector: 'app-dependencies',
  templateUrl: './dependencies.component.html',
  styleUrl: './dependencies.component.css',
})
export class DependenciesComponent implements OnInit {
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  isDependeciesLoading: boolean = false;
  stateOptions: any[] = [
    { label: 'Raised by me', value: 'raised-by-me' },
    { label: 'Raised to me', value: 'raised-to-me' },
  ];
  value: string = 'raised-to-me';
  raiseByMeLists: any;
  httpService = inject(HttpService);
  pageMetaData = inject(PageMetadataService);
  apiService = inject(ApiService);
  homeService = inject(HomeService);
  helper = inject(HelperService);
  sidebarService = inject(SidebarService);

  raiseToMeLists: any = [];
  isRaiseToMeLoading: boolean = false;
  isRaiseByMeLoading: boolean = false;
  isSidebarOpen: boolean = false;
  quarter: any;
  category: any;
  roleSubscription: any;
  currentYear: any;
  currentQuater: any;
  filterCount: number;
  constructor() {}


  ngOnInit() {
    this.pageMetaData.setTitle('Dependencies | OBP');

    this.fetchRaiseByMeData();
    this.fetchRaiseToMeData();
    this.breadCrumbItems = [{ label: 'To-Do' }, { label: 'Dependencies' }];

    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };

    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.category = data;
      this.fetchCurrentYear(data);
    });
  }

  fetchCurrentYear(cat: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/year`, {})
      .subscribe((res: any) => {
        this.currentYear = res?.data;
        this.fetchCurrentQuater();
      });
  }

  fetchCurrentQuater() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/quarter`, {})
      .subscribe((res: any) => {
        this.currentQuater = res?.data?.quarter;
        this.quarterList(this.category);
        this.dependeciesSelection({ quarter: this.currentQuater ,outcome_year:new Date().getFullYear(),});
      });
  }

  quarterList(cat: string) {
    const data = {
      year: this.currentYear,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  dependeciesSelection(filterData: any) {
    this.filterCount = this.helper.getFilledPropertiesCount(filterData);
    this.fetchRaiseByMeData(filterData);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  fetchRaiseByMeData(data?: any) {
    this.isRaiseByMeLoading = true;
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/dependencies/by/me`, {
        ...data,
      })
      .subscribe((res: any) => {
        this.raiseByMeLists = res?.data;
        this.isRaiseByMeLoading = false;
      });
  }

  fetchRaiseToMeData() {
    this.isRaiseToMeLoading = true;
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/dependencies/for/me`, {})
      .subscribe((res: any) => {
        this.raiseToMeLists = res?.data;
        this.isRaiseToMeLoading = false;
      });
  }

  updateReassingState(data:any){
    this.raiseByMeLists = this.raiseByMeLists.filter((v: any) => v?.dependency_id !== data?.dependency_id);
    this.raiseByMeLists.unshift(data);
  }

  updateDelegateState(data:any){
    this.raiseToMeLists = this.raiseToMeLists.filter((v: any) => v?.dependency_id !== data?.dependency_id);

  }
}
